const {db, auth} = require('./firebase')
const {EventBus} = require('./EventBus')
const System = {
  ref: db.ref('/System'),
  currentUser: {},
  getNegocio: (nId) => {
    return db.ref(`/Negocios/${nId}`).once('value')
  }
}
auth.onAuthStateChanged(auth => {
  if (auth) {
    System.currentUser['setNegocio'] = (nId) => {
      System.currentUser.ref.child('Negocio').set(nId)
    }
    System.currentUser['ref'] = db.ref(`/Users/${auth.uid}`)
    System.currentUser.ref.child('Info').on('value', snap => {
      if (!snap.exists()) {
        snap.ref.set(JSON.parse(JSON.stringify(auth)))
      } else {
        let info = JSON.parse(JSON.stringify(auth))
        info['stsTokenManager'] = null
        snap.ref.update(info)
        System.currentUser['Info'] = snap.val()
      }
    })
    System.currentUser.ref.child('Negocio').on('value', snap => {
      if (snap.exists()) {
        System.getNegocio(snap.val()).then(neg => {
          if (neg.exists()) {
             System.currentUser['Negocio'] = neg.val()
             System.currentUser['Negocio']['id'] = neg.key
          } else {
            System.currentUser['Negocio'] = null
          }
        })
      } else {
        System.currentUser['Negocio'] = null
      }
    })
    System.currentUser.ref.child('Negocios').on('value', snap => {
      if (snap.exists()) {
        if (!System.currentUser['Negocios']) {
          System.currentUser['Negocios'] = {}
        }
        let n = snap.val()
        Object.keys(n).forEach(nKey => {
          System.getNegocio(nKey).then(neg => {
            System.currentUser['Negocios'][nKey] = neg.val()
            System.currentUser['Negocios'][nKey]['id'] = nKey
          })
        })
      } else {
        System.currentUser['Negocios'] = null
      }
    })
  } else {
    System.currentUser = {}
  }
})
const Systemplugin = {
  install (Vue) {
    if (!Vue.prototype.$System) {
      Object.defineProperties(Vue.prototype, {
        $System: {
          get: function () {
            return System
          }
        }
      })
    }
  }
}
export {Systemplugin as default, System}